import React, { useState } from "react";
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonModal, IonTitle, IonToolbar } from "@ionic/react";
import { filterOutline, trash } from "ionicons/icons";

interface Props {
  number: number;
  setFilterDefault: () => void;
  activeFilterCount?: number;
}

const FilterModal: React.FC<Props> = (props) => {
  const { children, number } = props;
  const [isOpen, setIsOpen] = useState(false);
  const activeCount = props.activeFilterCount ?? 0;
  const hasActiveFilters = activeCount > 0;

  return (
    <>
      <div className="filterModalToolbar">
        <span></span>
        <div>
          {hasActiveFilters && props.setFilterDefault && (
            <IonButton onClick={props.setFilterDefault} color="danger" size="small">
              <IonIcon slot="start" icon={trash} />
              Szűrők törlése
            </IonButton>
          )}
          <IonButton onClick={() => setIsOpen(true)} color={hasActiveFilters ? "primary" : "medium"} size="small">
            <IonIcon slot="start" icon={filterOutline} />
            {hasActiveFilters ? `Szűrés (${activeCount})` : "Szűrés"}
          </IonButton>
        </div>
      </div>

      <IonModal backdropDismiss={false} isOpen={isOpen}>
        <IonHeader>
          <IonToolbar>
            <IonTitle>Szűrés</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setIsOpen(false)}>Bezár</IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          {children}

          <br />
          <div className="paddingForButton">
            <IonButton color="success" expand="block" onClick={() => setIsOpen(false)}>
              Szűrés
            </IonButton>
          </div>
        </IonContent>
      </IonModal>
    </>
  );
};

export default FilterModal;
